import { PayloadAction, createSlice } from '@reduxjs/toolkit';
const SRC = 'memory.slice.ts';

import { AppThunk } from 'store/store';
import { Path } from 'components/_hooks/use-router';

type Zoom = number;
type ScrollLeft = number;

export interface TracksSnapshot {
  zoom: Zoom;
  audioPosition: ScrollLeft;
  trackPositions: ScrollLeft[];
  cursorTime: EditorTime;
}

export interface StoreSnapshot {
  activeClip: CellClip;
}

export type Snapshot = TracksSnapshot & StoreSnapshot;

export interface SetSnapshot {
  snapshot: Snapshot;
  path: Path;
}

export const SNAPSHOT: Snapshot = {
  activeClip: null,
  audioPosition: 0,
  trackPositions: [],
  cursorTime: 0,
  zoom: 1,
};

export interface State {
  cameFrom: Path | null;
  selector: Snapshot | null;
  storyboard: Snapshot | null;
  finalcut: Snapshot | null;
  tracksRestored: boolean;
}

const initialState: State = {
  cameFrom: null,
  selector: null,
  storyboard: null,
  finalcut: null,
  tracksRestored: false,
};

// T H U N K S

export const setSnapshot =
  (payload: TracksSnapshot, path: Path): AppThunk =>
  async (dispatch, getState) => {
    const state = getState();
    if (!state.memory.tracksRestored) {
      console.log(`[${SRC}] setSnapshot`);
      return;
    }
    const activeClip = path === Path.finalcuts ? state.fc__controls.fcActiveClip : state.editor.activeClip;
    dispatch(memorySlice.actions.setSnapshot({ snapshot: { ...payload, activeClip }, path }));
  };
//

// S L I C E

export const memorySlice = createSlice({
  name: 'memory',
  initialState,
  reducers: {
    setCameFrom: (state, action: PayloadAction<Path>) => {
      state.cameFrom = action.payload;
    },
    setSnapshot: (state, action: PayloadAction<SetSnapshot>) => {
      const { snapshot, path } = action.payload;
      state.tracksRestored = false;
      switch (path) {
        case Path.selector:
          state.selector = snapshot;
          break;
        case Path.storyboard:
          state.storyboard = snapshot;
          break;
        case Path.finalcuts:
          state.finalcut = snapshot;
          break;
        default:
          break;
      }
    },
    setTracksRestored: (state) => {
      state.tracksRestored = true;
    },
  },
});

export const { setTracksRestored, setCameFrom } = memorySlice.actions;
export default memorySlice.reducer;
